// extracted by mini-css-extract-plugin
export default {"pageTitle":"CobraCensus_pageTitle__OmpWC","introduction":"CobraCensus_introduction__JGHCb"};